module.exports = __webpack_public_path__ + "static/img/blog_icon.673b313.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog_icon.svg
// module id = 7w85
// module chunks = 1